import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCalendarCheck = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.02 2a.75.75 0 0 1 .75.75v2.096h6.365a.75.75 0 0 1 0 1.5H7.769v2.096a.75.75 0 1 1-1.5 0V2.75A.75.75 0 0 1 7.02 2M2.635 5.483c.408-.408.96-.637 1.537-.637a.75.75 0 1 1 0 1.5.673.673 0 0 0-.673.673v12.808a.673.673 0 0 0 .673.673h15.654a.673.673 0 0 0 .673-.673V7.019a.673.673 0 0 0-.673-.673H17.73v2.096a.75.75 0 1 1-1.5 0V2.75a.75.75 0 0 1 1.5 0v2.096h2.096A2.173 2.173 0 0 1 22 7.02v12.808A2.173 2.173 0 0 1 19.827 22H4.173A2.173 2.173 0 0 1 2 19.827V7.019c0-.576.229-1.129.636-1.536m13.486 6.3a.75.75 0 0 0-1.129-.988l-4.523 5.169-2.29-1.718a.75.75 0 1 0-.9 1.2l2.847 2.135a.75.75 0 0 0 1.014-.106z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCalendarCheck;
